/** Maillage interne : guides techniques ↔ pages commerciales SEO. */

export const POPULAR_GUIDE_KEYS = [
  { guideKey: 'studioAudiovisuel', icon: 'bi-display' },
  { guideKey: 'obsWhip', icon: 'bi-camera-video' },
  { guideKey: 'blackhole', icon: 'bi-broadcast' },
  { guideKey: 'voicemeeterBanana', icon: 'bi-sliders' },
  { guideKey: 'loopback', icon: 'bi-diagram-3' },
  { guideKey: 'smartphoneLive', icon: 'bi-phone' },
];

/** Pages mises en avant sur la home (roadmap §11.1). Le guide OBS est dans POPULAR_GUIDE_KEYS. */
export const USE_CASE_LANDING_KEYS = [
  { pageKey: 'liveStreamingMusique', icon: 'bi-broadcast' },
  { pageKey: 'concertVirtuel', icon: 'bi-music-note-beamed' },
  { pageKey: 'repetitionMusiqueADistance', icon: 'bi-people' },
  { pageKey: 'diffusionConcertPrive', icon: 'bi-lock' },
  { pageKey: 'concertVirtuelPourAssociation', icon: 'bi-heart' },
  { pageKey: 'liveStreamingAssociationCulturelle', icon: 'bi-building' },
  { pageKey: 'audioLiveMusique', icon: 'bi-soundwave' },
  { pageKey: 'streamingConcertHelloasso', icon: 'bi-ticket-perforated' },
  { pageKey: 'plateformeLiveArtistes', icon: 'bi-mic' },
  { pageKey: 'webrtcMusiqueFaibleLatence', icon: 'bi-lightning' },
  { pageKey: 'references', icon: 'bi-star' },
];

/** Groupes de landing pages pour le maillage home / footer (découverte crawl). */
export const SEO_LANDING_GROUPS = [
  {
    id: 'solutions',
    pageKeys: [
      'liveStreamingMusique',
      'concertVirtuel',
      'repetitionMusiqueADistance',
      'studioAudiovisuelADistance',
      'plateformeLiveArtistes',
      'diffusionConcertPrive',
      'webrtcMusiqueFaibleLatence',
      'obsWhipLiveStreaming',
      'streamerConcertAvecObs',
      'audioLiveMusique',
    ],
  },
  {
    id: 'compare',
    pageKeys: [
      'gniarkLiveVsZoomMusique',
      'webrtcVsRtmpLiveStreaming',
      'obsWhipVsRtmp',
      'blackholeVsLoopback',
      'voicemeeterVsVbCable',
    ],
  },
  {
    id: 'verticals',
    pageKeys: [
      'liveStreamingPourMusiciens',
      'liveStreamingPourDj',
      'concertVirtuelPourAssociation',
      'studioDistancePourProducteur',
      'repetitionADistancePourGroupe',
      'streamingConcertHelloasso',
      'liveStreamingAssociationCulturelle',
    ],
  },
];

/** Liens footer SEO (pages profondes ou verticales peu liées depuis la home). */
export const FOOTER_SEO_LANDING_KEYS = [
  'audioLiveMusique',
  'liveStreamingAssociationCulturelle',
  'streamingConcertHelloasso',
  'webrtcVsRtmpLiveStreaming',
  'obsWhipVsRtmp',
  'blackholeVsLoopback',
  'voicemeeterVsVbCable',
  'gniarkLiveVsZoomMusique',
  'studioAudiovisuelADistance',
  'obsWhipLiveStreaming',
];

const FOOTER_SEO_KEY_SET = new Set(FOOTER_SEO_LANDING_KEYS);

/** Groupes footer alignés sur {@link SEO_LANDING_GROUPS} (solutions, comparatifs, publics). */
export const FOOTER_SEO_GROUPS = SEO_LANDING_GROUPS.map((group) => ({
  id: group.id,
  pageKeys: group.pageKeys.filter((key) => FOOTER_SEO_KEY_SET.has(key)),
})).filter((group) => group.pageKeys.length > 0);

/** Guide technique → page commerciale principale. */
export const GUIDE_TO_COMMERCIAL = {
  studioAudiovisuel: 'studioAudiovisuelADistance',
  obsWhip: 'obsWhipLiveStreaming',
  audioHijack: 'studioAudiovisuelADistance',
  loopback: 'audioLiveMusique',
  backgroundMusic: 'audioLiveMusique',
  blackhole: 'audioLiveMusique',
  virtualAudioCable: 'liveStreamingPourMusiciens',
  vbCable: 'liveStreamingPourMusiciens',
  voicemeeterBanana: 'liveStreamingPourDj',
  smartphoneLive: 'liveStreamingPourMusiciens',
};

/** Page commerciale → guides techniques connexes. */
export const LANDING_TO_GUIDES = {
  liveStreamingMusique: ['studioAudiovisuel', 'obsWhip'],
  concertVirtuel: ['studioAudiovisuel', 'smartphoneLive'],
  repetitionMusiqueADistance: ['studioAudiovisuel', 'blackhole'],
  studioAudiovisuelADistance: [
    'studioAudiovisuel',
    'obsWhip',
    'audioHijack',
    'loopback',
    'backgroundMusic',
    'blackhole',
    'virtualAudioCable',
    'vbCable',
    'voicemeeterBanana',
    'smartphoneLive',
  ],
  plateformeLiveArtistes: ['studioAudiovisuel', 'obsWhip'],
  diffusionConcertPrive: ['studioAudiovisuel', 'obsWhip'],
  webrtcMusiqueFaibleLatence: ['studioAudiovisuel', 'obsWhip'],
  obsWhipLiveStreaming: ['obsWhip', 'studioAudiovisuel'],
  gniarkLiveVsZoomMusique: ['studioAudiovisuel'],
  webrtcVsRtmpLiveStreaming: ['obsWhip', 'studioAudiovisuel'],
  obsWhipVsRtmp: ['obsWhip'],
  blackholeVsLoopback: ['blackhole', 'loopback'],
  voicemeeterVsVbCable: ['voicemeeterBanana', 'vbCable'],
  liveStreamingPourMusiciens: ['studioAudiovisuel', 'smartphoneLive', 'obsWhip'],
  liveStreamingPourDj: ['obsWhip', 'voicemeeterBanana'],
  concertVirtuelPourAssociation: ['studioAudiovisuel', 'smartphoneLive'],
  studioDistancePourProducteur: ['studioAudiovisuel', 'obsWhip', 'audioHijack'],
  repetitionADistancePourGroupe: ['studioAudiovisuel', 'blackhole', 'loopback'],
  aPropos: ['studioAudiovisuel', 'obsWhip'],
  references: ['obsWhip', 'smartphoneLive', 'blackhole', 'voicemeeterBanana'],
  streamingConcertHelloasso: ['studioAudiovisuel', 'smartphoneLive'],
  streamerConcertAvecObs: ['obsWhip', 'studioAudiovisuel', 'voicemeeterBanana'],
  audioLiveMusique: ['blackhole', 'loopback', 'voicemeeterBanana', 'studioAudiovisuel'],
  liveStreamingAssociationCulturelle: ['studioAudiovisuel', 'smartphoneLive', 'obsWhip'],
};

export const GUIDE_PATH_BY_KEY = {
  studioAudiovisuel: '/help/studio-audiovisuel-a-distance',
  obsWhip: '/help/obs-whip',
  audioHijack: '/help/audio-hijack',
  loopback: '/help/loopback',
  backgroundMusic: '/help/background-music',
  blackhole: '/help/blackhole',
  virtualAudioCable: '/help/virtual-audio-cable',
  vbCable: '/help/vb-cable',
  voicemeeterBanana: '/help/voicemeeter-banana',
  smartphoneLive: '/help/smartphone-live',
};
